module.exports = __webpack_public_path__ + "a7feab2f31a62cad8e53af2b3c1c4180.svg";